import React from 'react'
import PhoneIcon from '../assets/phone.svg'
import MailIcon from '../assets/mail.svg'
import MapIcon from '../assets/map-pin-line.svg'
import TimerIcon from '../assets/timer.svg'
import { Helmet } from 'react-helmet'
import { Link } from 'react-router-dom'

const ContactUs = () => {

    const contactData = [
        {
            img: PhoneIcon,
            name: 'Phone',
            desc: '(123) 456-7890'
        },
        {
            img: MapIcon,
            name: 'Address',
            desc: '1901 Thornridge Cir. Shiloh, Hawaii 81063'
        },
        {
            img: MailIcon,
            name: 'Mail',
            desc: 'SupremeNutrashop@gmail.com'
        },
        {
            img: TimerIcon,
            name: 'Opening Hours',
            desc: 'Monday – Friday 7 AM to 4 PM PST'
        },

    ]


    return (
        <div className='bg-white md:py-[100px] p-10 w-full px-[4%] sm:px-[6%] xl:px-[10%] 2xl:px-[12.6%]'>
            <Helmet>
                <title>Contact Us - Supreme Nutra Shop</title>
                <meta name="description" content="This is a detailed description of the page content for better SEO" />
                <meta name="robots" content="index, follow" />
                <meta property="og:title" content="My SEO Optimized Page" />
                <meta property="og:description" content="This is a detailed description of the page content for better SEO" />
                <meta property="og:image" content="https://www.example.com/image.jpg" />
                <link rel="canonical" href="https://www.example.com/page" />
            </Helmet>
            <div className='capitalize text-[clamp(1.8rem,4vw,2.5rem)] font-[600] leading-[clamp(2rem,5vw,3.125rem)]'>
                <span className='text-primary'>Contact </span>
                <span className='text-black'>Us</span>
            </div>
            <div className='mt-10 flex justify-center '>
                <div className='grid gap-10 md:grid-cols-2 '>
                    {
                        contactData.map((item, inx) => (
                            <div key={inx} className='shadow-custom py-[30px] md:px-[49px] rounded-[20px] flex flex-col items-center'>
                                <img src={item.img} alt={item.name} />
                                <p className='pb-[21px] pt-[14px] text-[24px] font-[600] leading-8'>{item.name}</p>
                                {
                                    (item.name === "Mail" || item.name === "Phone") ?
                                        <Link to={item.name === "Mail" ? `mailto:${item.desc.toLowerCase()}` : `tel:${item.desc}`} className='text-[clamp(1rem,4vw,1.25rem)] font-[400] leading-8 text-secondary px-5 hover:text-black'>{item.desc}</Link>
                                        :
                                        <p className='text-[clamp(1rem,4vw,1.25rem)] font-[400] leading-8 text-secondary px-5'>{item.desc}</p>
                                }
                            </div>
                        ))
                    }
                </div>
            </div>
        </div>
    )
}

export default ContactUs